import { render } from "./Pass.vue?vue&type=template&id=37110965&ts=true"
import script from "./Pass.vue?vue&type=script&lang=ts"
export * from "./Pass.vue?vue&type=script&lang=ts"

import "./Pass.vue?vue&type=style&index=0&id=37110965&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__